import { Typography } from "@mui/material";

export default function PoweredBy(props) {
  return (
    <Typography
      mt="auto"
      pb={2}
      pt={3}
      variant="body2"
      textAlign="center"
      {...props}
    >
      Powered by GO Digital Services
    </Typography>
  );
}
